/**
 * Created by Alican Köker on 2018-08-23.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {BonusMultiplier} from "./BonusMultiplier";

export class FruitsBonusIndicator extends PIXI.Container {

    private _container:PIXI.Container;
    private _multipliers:BonusMultiplier[] = [];
    private _initialMultiplierValues:number[] = [5, 6, 7, 8, 9, 10, 15, 25, 50, 100];
    private _multiplierValues:number[] = [5, 6, 7, 8, 9, 10, 15, 25, 50, 100];
    private _multiplierUpdateValues:number[] = [1, 1, 1, 2, 2, 3, 5, 7, 15, 25];
    private _noOfMultipliers:number = 10;

    public _currentIndex:number = 0;

    constructor() {
        super();

        this._container = new PIXI.Container();
        this.addChild(this._container);
        this.init();
    }

    private init():void {
        for(let i:number = 0; i < this._noOfMultipliers; i++) {
            let multiplier:BonusMultiplier = new BonusMultiplier(i);
            this._multipliers.push(multiplier);
            if(i !== this._currentIndex) {
                this._container.addChild(this._multipliers[i]);
                this._multipliers[i].setValue(this._multiplierValues[i]);
                this._multipliers[i].position.set(0, (9 - i) * 90);
                if(this._currentIndex > i)
                    this._multipliers[i].enableMultiplier();
                else if(this._currentIndex < i)
                    this._multipliers[i].disableMultiplier();
            }
        }
        this._multipliers[this._currentIndex].position.set(0, (9 - this._currentIndex) * 90);
        this._multipliers[this._currentIndex].activateMultiplier();
        this._multipliers[this._currentIndex].setValue(this._multiplierValues[this._currentIndex]);
        this._container.addChild(this._multipliers[this._currentIndex]);
        this.reOrder(this._currentIndex);
    }

    public update(values?:boolean, newIndex?:boolean):void {
        let startIndex = newIndex ? this._currentIndex - 1 : 0;
        let endIndex = newIndex ? this._currentIndex + 1 : this._noOfMultipliers;

        if(values) {
            for(let i:number = 0; i < 10; i++) {
                this._multiplierValues[i] += this._multiplierUpdateValues[i];
            }
        }

        let tl:TimelineLite = new TimelineLite();
        for(let i:number = startIndex; i < endIndex; i++) {
            tl.add(() => {
                if(this._currentIndex > i)
                    this._multipliers[i].playHighlightAnimation("disabled", this._multiplierValues[i], i === 9);
                else if(this._currentIndex < i)
                    this._multipliers[i].playHighlightAnimation("enabled", this._multiplierValues[i], i === 9);
                else {
                    this.reOrder(i);
                    this._multipliers[i].playHighlightAnimation("active", this._multiplierValues[i], i === 9);
                }
                if(i !== startIndex && newIndex)
                    SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_METER_UP);
                if(i === this._currentIndex)
                    SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_NEW_LEVEL);
                if(values) {
                    if(i === startIndex)
                        SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_METER_LEVEL_UP);
                }

            }, i * .1);
        }
        tl.play();
    }

    private reOrder(activeIndex:number):void {
        this._container.removeChildren();
        for(let i:number = 0; i < this._noOfMultipliers; i++) {
            if(i !== activeIndex)
                this._container.addChild(this._multipliers[i])
        }
        this._container.addChild(this._multipliers[activeIndex]);
    }

    public refresh():void {
        for(let i:number = 0; i < this._noOfMultipliers; i++) {
            if(this._currentIndex > i) {
                this._multipliers[i].disableMultiplier();
            } else if(this._currentIndex < i) {
                this._multipliers[i].enableMultiplier();
            } else {
                this.reOrder(i);
                this._multipliers[i].activateMultiplier();
            }
            this._multipliers[i].setValue(this._multiplierValues[i]);
        }
    }

    public updateMultiplierValues(values:number[]):void {
        for(let i:number = 0; i < this._multipliers.length; i++) {
            this._multipliers[i].setValue(values[i]);
            this._multiplierValues[i] = values[i];
        }
    }

    public setIndicator(values:number[], newIndex:number):void {
        this._currentIndex = newIndex;
        this._multiplierValues = values;
        this.refresh();
    }

    public reset(values?:number[]):void {
        if(values)
            this._multiplierValues = values;
        else
            this._multiplierValues = this._initialMultiplierValues;

        this._currentIndex = 0;

        this.refresh();
    }
}